export default __webpack_public_path__ + "static/media/cemento-destacado.334e2410.png";